import React from 'react'
import { ReactComponent } from './realization.svg'
import { MergeReactElementProps } from '@komune-io/g2-utils'

interface RealizationProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', RealizationProps>

export const RealizationIcon = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = '#828282' } = props
    return <ReactComponent fill={color} ref={ref} {...props} />
  }
)
